import { IStaffCourseSummary, IStudentCourseSummary } from '../interfaces'
import { Course } from './Course'

export class CoursesByPersonIdResponse {
  constructor (
    readonly student: IStudentCourseSummary[],
    readonly staff: IStaffCourseSummary[]
  ) {}
}
